import { PENDING_PAYMENT_METHOD_STORAGE_KEY } from 'features/pricing/constants/paymentMethodFlowConstants';

export function markPendingPaymentMethodUpdate(paymentMethodId: string) {
  sessionStorage.setItem(PENDING_PAYMENT_METHOD_STORAGE_KEY, paymentMethodId);
}

export function getPendingPaymentMethodUpdateId(): string | null {
  return sessionStorage.getItem(PENDING_PAYMENT_METHOD_STORAGE_KEY);
}

export function clearPendingPaymentMethodUpdate() {
  sessionStorage.removeItem(PENDING_PAYMENT_METHOD_STORAGE_KEY);
}
